import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import AddWeightModal from "./AddWeightModal";
import ScaleOutlinedIcon from "@mui/icons-material/ScaleOutlined";
import { StopNew } from "../../../ducks/data/route-with-stops/types";

const AddWeightModalAndButton = (input: { stop: StopNew }) => {
  const { stop } = input;
  const [showAddWeightDialog, setShowAddWeightDialog] = useState(false);
  const { t } = useTranslation(["stopPage"]);

  return (
    <>
      {showAddWeightDialog && (
        <AddWeightModal
          stop={stop}
          onClose={() => setShowAddWeightDialog(false)}
        />
      )}
      <Button
        onClick={() => setShowAddWeightDialog(true)}
        variant="outlined"
        size="large"
        startIcon={<ScaleOutlinedIcon />}
      >
        {t("stopPage:addWeight")}
        {stop.weightAdded && <CheckIcon />}
      </Button>
    </>
  );
};

export default AddWeightModalAndButton;
